(function () {
    'use strict';

    angular
        .module('loyalty')
        .controller('LoyaltyServiceRedeemedController', LoyaltyServiceRedeemedController);
    LoyaltyServiceRedeemedController.$inject = ['LoyaltyService', '$uibModal'];
    function LoyaltyServiceRedeemedController(LoyaltyService, $uibModal) {
        var vm = this;
        vm.flag = false;
        vm.activate = activate;
        vm.serviceSelected = '';
        vm.serviceStatus = [{id : -1, name : 'All'},{id : 1, name : 'Yes'}, {id : 0, name : 'No'}];
        vm.serviceStatusSelected = {id : -1, name : 'All'};
        vm.dateRangeA   = '';
        vm.clientNameOrEmail   = '';
        vm.getByFilter = getByFilter;
        vm.reverseRedeem = reverseRedeem;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            // vm.getProgramItems();
        }

        function getByFilter()
        {
            vm.flag = false;
            vm.query = {};
            vm.query['page'] = vm.page;
            vm.query['client'] = vm.clientNameOrEmail;
            vm.query['status'] = vm.serviceStatusSelected.id;
            if(vm.dateRangeA !== '' && vm.dateRangeA !== 'undefined')
            {
                vm.query['startDate'] = new Date(vm.dateRangeA.startDate);
                vm.query['endDate'] = new Date(vm.dateRangeA.endDate);
            }

            LoyaltyService.getItemUsers(vm.query).then(function(response) {
                vm.flag = true;
                vm.items = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function reverseRedeem(item)
        {
            alertify
                .confirm('Do you really reverse ' + item.description + ' for ' + item.name + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    vm.query = {};
                    vm.query['id']  = item.id;
                    console.log(item);
                    LoyaltyService.reverseRedeem(vm.query).then(function(response) {
                        vm.items.splice(vm.items.indexOf(item), 1);
                        alertify.notify('Service item successfully reversed!', 'success', 3);
                    }).catch(function(err) {
                    });
                })
                .show();
        }

        function activate()
        {
            vm.getByFilter();
        }

        vm.activate();
    }
})();